import ProcessInstanceListPage from './ProcessInstanceListPage';

export default ProcessInstanceListPage;
